import { TimelinePersonRow } from './TimelinePersonRow';
import { TimelineSectionHeader } from './TimelineSectionHeader';
import { TimelineTaskRow } from './TimelineTaskRow';
import type { TimelineGroupBy } from '../../utils/timeline-group-builder';
import type { TimelineGroupSection, TimelinePersonRowModel } from '../../types';

interface TimelineRowsProps {
  timelineGroupBy: TimelineGroupBy | null;
  sections: TimelineGroupSection[];
  rows: TimelinePersonRowModel[];
  columnCount: number;
  columnWidthPx: number;
  windowStart: Date;
  windowEnd: Date;
  onTaskClick: (taskId: string) => void;
}

/** Renders either the grouped-sections layout (status/priority/group) or the swimlane-by-person layout (assignee/none). */
export function TimelineRows({
  timelineGroupBy,
  sections,
  rows,
  columnCount,
  columnWidthPx,
  windowStart,
  windowEnd,
  onTaskClick,
}: TimelineRowsProps) {
  if (timelineGroupBy) {
    return (
      <>
        {sections.map((section) => (
          <div key={section.key}>
            <TimelineSectionHeader
              groupKey={section.key}
              label={section.label}
              color={section.color}
              count={section.count}
            />
            {section.rows.map((task) => (
              <TimelineTaskRow
                key={task.id}
                task={task}
                columnCount={columnCount}
                columnWidthPx={columnWidthPx}
                windowStart={windowStart}
                windowEnd={windowEnd}
                onTaskClick={onTaskClick}
              />
            ))}
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {rows.map((row) => (
        <TimelinePersonRow
          key={row.person.id}
          row={row}
          columnCount={columnCount}
          columnWidthPx={columnWidthPx}
          windowStart={windowStart}
          windowEnd={windowEnd}
          onTaskClick={onTaskClick}
        />
      ))}
    </>
  );
}
